// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VisibilityRouteRouteImport } from './routes/_visibility/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VisibilityTopnavRouteRouteImport } from './routes/_visibility/_topnav/route'
import { Route as VisibilityStandaloneRouteRouteImport } from './routes/_visibility/_standalone/route'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthRedefinirSenhaRouteImport } from './routes/_auth/redefinir-senha'
import { Route as AuthJoinRouteImport } from './routes/_auth/join'
import { Route as AuthEsqueciASenhaRouteImport } from './routes/_auth/esqueci-a-senha'
import { Route as AuthnoAuthRouteRouteImport } from './routes/_auth/(no-auth)/route'
import { Route as VisibilityTopnavSearchRouteImport } from './routes/_visibility/_topnav/search'
import { Route as VisibilityTopnavPostsAgendadosRouteImport } from './routes/_visibility/_topnav/posts-agendados'
import { Route as VisibilityTopnavRankingRouteRouteImport } from './routes/_visibility/_topnav/ranking/route'
import { Route as AuthnoAuthLoginRouteImport } from './routes/_auth/(no-auth)/login'
import { Route as AuthnoAuthCadastroRouteImport } from './routes/_auth/(no-auth)/cadastro'
import { Route as VisibilityTopnavUUsernameRouteImport } from './routes/_visibility/_topnav/u.$username'
import { Route as VisibilityTopnavPostsNovoRouteImport } from './routes/_visibility/_topnav/posts.novo'
import { Route as VisibilityTopnavNotificacoesConfiguracoesRouteImport } from './routes/_visibility/_topnav/notificacoes.configuracoes'
import { Route as VisibilityTopnavEventosNovoRouteImport } from './routes/_visibility/_topnav/eventos.novo'
import { Route as VisibilityTopnavTabsEventosRouteImport } from './routes/_visibility/_topnav/_tabs/eventos'
import { Route as VisibilityTopnavTabsCursosRouteImport } from './routes/_visibility/_topnav/_tabs/cursos'
import { Route as VisibilityTopnavRankingPontuacaoRouteImport } from './routes/_visibility/_topnav/ranking/pontuacao'
import { Route as VisibilityTopnavRankingLeaderboardRouteImport } from './routes/_visibility/_topnav/ranking/leaderboard'
import { Route as VisibilitySSpacePostPostRouteImport } from './routes/_visibility/s.$space.post.$post'
import { Route as VisibilityTopnavEventosSlugIndexRouteImport } from './routes/_visibility/_topnav/eventos.$slug.index'
import { Route as VisibilityTopnavPostsSlugEditarRouteImport } from './routes/_visibility/_topnav/posts.$slug.editar'
import { Route as VisibilityTopnavEventosSlugEditarRouteImport } from './routes/_visibility/_topnav/eventos.$slug.editar'
import { Route as VisibilityTopnavComunidadeSSpaceRouteRouteImport } from './routes/_visibility/_topnav/comunidade/s/$space/route'
import { Route as VisibilityTopnavTabsSidebarComunidadeRouteRouteImport } from './routes/_visibility/_topnav/_tabs/_sidebar/comunidade/route'
import { Route as VisibilityStandaloneCursosCourseIndexRouteImport } from './routes/_visibility/_standalone/cursos.$course.index'
import { Route as VisibilityStandaloneCursosCourseLessonRouteImport } from './routes/_visibility/_standalone/cursos.$course.$lesson'
import { Route as VisibilityTopnavTabsSidebarComunidadeIndexRouteImport } from './routes/_visibility/_topnav/_tabs/_sidebar/comunidade/index'
import { Route as VisibilityTopnavComunidadeSSpacePostsPostRouteImport } from './routes/_visibility/_topnav/comunidade/s/$space/posts.$post'
import { Route as VisibilityTopnavTabsSidebarComunidadeSSpaceRouteImport } from './routes/_visibility/_topnav/_tabs/_sidebar/comunidade/s.$space'

const VisibilityRouteRoute = VisibilityRouteRouteImport.update({
            id: '/_visibility',getParentRoute: () => rootRouteImport
          })
const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const VisibilityTopnavRouteRoute = VisibilityTopnavRouteRouteImport.update({
            id: '/_topnav',getParentRoute: () => VisibilityRouteRoute
          })
const VisibilityStandaloneRouteRoute = VisibilityStandaloneRouteRouteImport.update({
            id: '/_standalone',getParentRoute: () => VisibilityRouteRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRouteRoute
          })
const AuthRedefinirSenhaRoute = AuthRedefinirSenhaRouteImport.update({
            id: '/redefinir-senha',path: '/redefinir-senha',getParentRoute: () => AuthRouteRoute
          })
const AuthJoinRoute = AuthJoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => AuthRouteRoute
          })
const AuthEsqueciASenhaRoute = AuthEsqueciASenhaRouteImport.update({
            id: '/esqueci-a-senha',path: '/esqueci-a-senha',getParentRoute: () => AuthRouteRoute
          })
const AuthnoAuthRouteRoute = AuthnoAuthRouteRouteImport.update({
            id: '/(no-auth)',getParentRoute: () => AuthRouteRoute
          })
const VisibilityTopnavSearchRoute = VisibilityTopnavSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavPostsAgendadosRoute = VisibilityTopnavPostsAgendadosRouteImport.update({
            id: '/posts-agendados',path: '/posts-agendados',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavRankingRouteRoute = VisibilityTopnavRankingRouteRouteImport.update({
            id: '/ranking',path: '/ranking',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const AuthnoAuthLoginRoute = AuthnoAuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthnoAuthRouteRoute
          })
const AuthnoAuthCadastroRoute = AuthnoAuthCadastroRouteImport.update({
            id: '/cadastro',path: '/cadastro',getParentRoute: () => AuthnoAuthRouteRoute
          })
const VisibilityTopnavUUsernameRoute = VisibilityTopnavUUsernameRouteImport.update({
            id: '/u/$username',path: '/u/$username',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavPostsNovoRoute = VisibilityTopnavPostsNovoRouteImport.update({
            id: '/posts/novo',path: '/posts/novo',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavNotificacoesConfiguracoesRoute = VisibilityTopnavNotificacoesConfiguracoesRouteImport.update({
            id: '/notificacoes/configuracoes',path: '/notificacoes/configuracoes',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavEventosNovoRoute = VisibilityTopnavEventosNovoRouteImport.update({
            id: '/eventos/novo',path: '/eventos/novo',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavTabsEventosRoute = VisibilityTopnavTabsEventosRouteImport.update({
            id: '/_tabs/eventos',path: '/eventos',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavTabsCursosRoute = VisibilityTopnavTabsCursosRouteImport.update({
            id: '/_tabs/cursos',path: '/cursos',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavRankingPontuacaoRoute = VisibilityTopnavRankingPontuacaoRouteImport.update({
            id: '/pontuacao',path: '/pontuacao',getParentRoute: () => VisibilityTopnavRankingRouteRoute
          })
const VisibilityTopnavRankingLeaderboardRoute = VisibilityTopnavRankingLeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => VisibilityTopnavRankingRouteRoute
          })
const VisibilitySSpacePostPostRoute = VisibilitySSpacePostPostRouteImport.update({
            id: '/s/$space/post/$post',path: '/s/$space/post/$post',getParentRoute: () => VisibilityRouteRoute
          })
const VisibilityTopnavEventosSlugIndexRoute = VisibilityTopnavEventosSlugIndexRouteImport.update({
            id: '/eventos/$slug/',path: '/eventos/$slug/',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavPostsSlugEditarRoute = VisibilityTopnavPostsSlugEditarRouteImport.update({
            id: '/posts/$slug/editar',path: '/posts/$slug/editar',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavEventosSlugEditarRoute = VisibilityTopnavEventosSlugEditarRouteImport.update({
            id: '/eventos/$slug/editar',path: '/eventos/$slug/editar',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavComunidadeSSpaceRouteRoute = VisibilityTopnavComunidadeSSpaceRouteRouteImport.update({
            id: '/comunidade/s/$space',path: '/comunidade/s/$space',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityTopnavTabsSidebarComunidadeRouteRoute = VisibilityTopnavTabsSidebarComunidadeRouteRouteImport.update({
            id: '/_tabs/_sidebar/comunidade',path: '/comunidade',getParentRoute: () => VisibilityTopnavRouteRoute
          })
const VisibilityStandaloneCursosCourseIndexRoute = VisibilityStandaloneCursosCourseIndexRouteImport.update({
            id: '/cursos/$course/',path: '/cursos/$course/',getParentRoute: () => VisibilityStandaloneRouteRoute
          })
const VisibilityStandaloneCursosCourseLessonRoute = VisibilityStandaloneCursosCourseLessonRouteImport.update({
            id: '/cursos/$course/$lesson',path: '/cursos/$course/$lesson',getParentRoute: () => VisibilityStandaloneRouteRoute
          })
const VisibilityTopnavTabsSidebarComunidadeIndexRoute = VisibilityTopnavTabsSidebarComunidadeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VisibilityTopnavTabsSidebarComunidadeRouteRoute
          })
const VisibilityTopnavComunidadeSSpacePostsPostRoute = VisibilityTopnavComunidadeSSpacePostsPostRouteImport.update({
            id: '/posts/$post',path: '/posts/$post',getParentRoute: () => VisibilityTopnavComunidadeSSpaceRouteRoute
          })
const VisibilityTopnavTabsSidebarComunidadeSSpaceRoute = VisibilityTopnavTabsSidebarComunidadeSSpaceRouteImport.update({
            id: '/s/$space',path: '/s/$space',getParentRoute: () => VisibilityTopnavTabsSidebarComunidadeRouteRoute
          })





const AuthnoAuthRouteRouteChildren = {
  AuthnoAuthCadastroRoute: AuthnoAuthCadastroRoute,AuthnoAuthLoginRoute: AuthnoAuthLoginRoute
}

const AuthnoAuthRouteRouteWithChildren = AuthnoAuthRouteRoute._addFileChildren(AuthnoAuthRouteRouteChildren)



const AuthRouteRouteChildren = {
  AuthnoAuthRouteRoute: AuthnoAuthRouteRouteWithChildren,AuthEsqueciASenhaRoute: AuthEsqueciASenhaRoute,AuthJoinRoute: AuthJoinRoute,AuthRedefinirSenhaRoute: AuthRedefinirSenhaRoute,AuthResetPasswordRoute: AuthResetPasswordRoute
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(AuthRouteRouteChildren)




const VisibilityStandaloneRouteRouteChildren = {
  VisibilityStandaloneCursosCourseLessonRoute: VisibilityStandaloneCursosCourseLessonRoute,VisibilityStandaloneCursosCourseIndexRoute: VisibilityStandaloneCursosCourseIndexRoute
}

const VisibilityStandaloneRouteRouteWithChildren = VisibilityStandaloneRouteRoute._addFileChildren(VisibilityStandaloneRouteRouteChildren)




const VisibilityTopnavRankingRouteRouteChildren = {
  VisibilityTopnavRankingLeaderboardRoute: VisibilityTopnavRankingLeaderboardRoute,VisibilityTopnavRankingPontuacaoRoute: VisibilityTopnavRankingPontuacaoRoute
}

const VisibilityTopnavRankingRouteRouteWithChildren = VisibilityTopnavRankingRouteRoute._addFileChildren(VisibilityTopnavRankingRouteRouteChildren)




const VisibilityTopnavTabsSidebarComunidadeRouteRouteChildren = {
  VisibilityTopnavTabsSidebarComunidadeIndexRoute: VisibilityTopnavTabsSidebarComunidadeIndexRoute,VisibilityTopnavTabsSidebarComunidadeSSpaceRoute: VisibilityTopnavTabsSidebarComunidadeSSpaceRoute
}

const VisibilityTopnavTabsSidebarComunidadeRouteRouteWithChildren = VisibilityTopnavTabsSidebarComunidadeRouteRoute._addFileChildren(VisibilityTopnavTabsSidebarComunidadeRouteRouteChildren)




const VisibilityTopnavComunidadeSSpaceRouteRouteChildren = {
  VisibilityTopnavComunidadeSSpacePostsPostRoute: VisibilityTopnavComunidadeSSpacePostsPostRoute
}

const VisibilityTopnavComunidadeSSpaceRouteRouteWithChildren = VisibilityTopnavComunidadeSSpaceRouteRoute._addFileChildren(VisibilityTopnavComunidadeSSpaceRouteRouteChildren)



const VisibilityTopnavRouteRouteChildren = {
  VisibilityTopnavRankingRouteRoute: VisibilityTopnavRankingRouteRouteWithChildren,VisibilityTopnavPostsAgendadosRoute: VisibilityTopnavPostsAgendadosRoute,VisibilityTopnavSearchRoute: VisibilityTopnavSearchRoute,VisibilityTopnavTabsCursosRoute: VisibilityTopnavTabsCursosRoute,VisibilityTopnavTabsEventosRoute: VisibilityTopnavTabsEventosRoute,VisibilityTopnavEventosNovoRoute: VisibilityTopnavEventosNovoRoute,VisibilityTopnavNotificacoesConfiguracoesRoute: VisibilityTopnavNotificacoesConfiguracoesRoute,VisibilityTopnavPostsNovoRoute: VisibilityTopnavPostsNovoRoute,VisibilityTopnavUUsernameRoute: VisibilityTopnavUUsernameRoute,VisibilityTopnavTabsSidebarComunidadeRouteRoute: VisibilityTopnavTabsSidebarComunidadeRouteRouteWithChildren,VisibilityTopnavComunidadeSSpaceRouteRoute: VisibilityTopnavComunidadeSSpaceRouteRouteWithChildren,VisibilityTopnavEventosSlugEditarRoute: VisibilityTopnavEventosSlugEditarRoute,VisibilityTopnavPostsSlugEditarRoute: VisibilityTopnavPostsSlugEditarRoute,VisibilityTopnavEventosSlugIndexRoute: VisibilityTopnavEventosSlugIndexRoute
}

const VisibilityTopnavRouteRouteWithChildren = VisibilityTopnavRouteRoute._addFileChildren(VisibilityTopnavRouteRouteChildren)



const VisibilityRouteRouteChildren = {
  VisibilityStandaloneRouteRoute: VisibilityStandaloneRouteRouteWithChildren,VisibilityTopnavRouteRoute: VisibilityTopnavRouteRouteWithChildren,VisibilitySSpacePostPostRoute: VisibilitySSpacePostPostRoute
}

const VisibilityRouteRouteWithChildren = VisibilityRouteRoute._addFileChildren(VisibilityRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRouteRoute: AuthRouteRouteWithChildren,VisibilityRouteRoute: VisibilityRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)